module.exports = __webpack_public_path__ + "img/shenhese.c587de9e.png";